import ServiceChannel from "@/components/serviceChannel/index.vue";
import { getLocalStorage, setLocalStorage } from "@/lobby_common/utils/auth.js";
import { isMobile } from "@/lobby_common/utils/utils.js";
import kefuPic from "@/assets/user/kefu_pic.png";
let isMove = false;
export default {
  name: "CustomerService",
  props: {},
  components: { ServiceChannel },
  data() {
    return {
      kefuPic,
      show: false,
      isMobile,
      lang: this.$store.getters.getLang,
      kehuWindow: process.env.VUE_APP_WEB_TYPE_NODE,
      customServiceConfig: {},
      iframeType: false,
    };
  },
  directives: {
    drag: {
      // 在要拖拽的元素上加 v-drag
      // 指令的定义
      bind: function (el, { value }, vNode) {
        const odiv = el; // 获取当前元素
        const that = vNode.context;
        if (isMobile()) {
          let startX = "";
          let startY = "";
          odiv.ontouchstart = function (e) {
            const rect = odiv.getBoundingClientRect();
            startX = rect.left;
            startY = rect.top;
          };
          odiv.ontouchend = function (e) {
            const rect = odiv.getBoundingClientRect();
            const endX = rect.left;
            const endY = rect.top;
            if (Math.abs(endX - startX) > 5 || Math.abs(endY - startY)) {
              const obj = getLocalStorage("position") || {};
              setLocalStorage("position", {
                ...obj,
                [odiv.id]: rect.left + "," + rect.top,
              });
            }
          };
          odiv.ontouchmove = function (e) {
            // console.log("移动中", e);
            e.preventDefault();
            if (e.targetTouches.length === 1) {
              odiv.style.transition = "none";
              odiv.style.position = "fixed";
              // 边界判断
              const maxleft =
                document.documentElement.clientWidth - odiv?.offsetWidth;
              const maxtop =
                document.documentElement.clientHeight - odiv?.offsetWidth - 60;
              // 一根手指
              const touch = e.targetTouches[0];
              let left = touch.clientX - 25 < 0 ? 0 : touch.clientX - 25;
              let top = touch.clientY - 25 < 0 ? 0 : touch.clientY - 25;
              top = top > maxtop ? maxtop : top;
              left = left > maxleft ? maxleft : left;

              odiv.style.left = left + "px";
              odiv.style.top = top + "px";
            }
          };
        } else {
          odiv.onmousedown = function (e) {
            // 算出鼠标相对元素的位置
            const startX = e.clientX;
            const startY = e.clientY;
            const rect = odiv.getBoundingClientRect();
            let starL = rect.left;
            const starT = rect.top;

            const maxLeft =
              document.documentElement?.offsetWidth - odiv?.offsetWidth;
            starL = starL > maxLeft ? maxLeft : starL;

            document.onmousemove = function (ev) {
              if (
                Math.abs(ev.clientX - startX) > 10 ||
                Math.abs(ev.clientY - startY) > 10
              ) {
                if (!isMove) {
                  isMove = true;
                }
                if (that.show) {
                  that.show = false;
                }
                odiv.style.transition = "none";
                odiv.style.position = "fixed";
                // 元素的位置
                let left = ev.clientX - startX + starL;
                let top = ev.clientY - startY + starT;

                // 边界判断
                const maxLeft1 =
                  document.documentElement?.offsetWidth - odiv?.offsetWidth;
                const maxtop =
                  document.documentElement.clientHeight - odiv?.offsetWidth;
                const minLeft = 0;
                left = left > maxLeft1 ? maxLeft1 : left;
                left = left < minLeft ? minLeft : left;
                top = top > maxtop ? maxtop : top;
                top = top < minLeft ? minLeft : top;
                // 绑定元素位置到positionX和positionY上面
                this.positionX = top;
                this.positionY = left;
                // 移动当前元素
                odiv.style.left = left + "px";
                odiv.style.top = top + "px";
              }
            };
            document.onmouseup = (en) => {
              // const boxLeft = parseInt(odiv.style.left);
              // const pageX = document.documentElement?.offsetWidth - odiv?.offsetWidth;
              const endX = en.clientX;
              const endY = en.clientY;
              const obj = getLocalStorage("position") || {};
              const arr = obj["888"]?.split(",") || [];
              const startX1 = arr[0] || 0;
              const startY2 = arr[1] || 0;
              if (
                isMove &&
                (Math.abs(endX - startX1) > 5 || Math.abs(endY - startY2))
              ) {
                const obj = getLocalStorage("position") || {};
                const rect = odiv.getBoundingClientRect();
                setLocalStorage("position", {
                  ...obj,
                  [odiv.id]: rect.left + "," + rect.top,
                });
              }

              document.onmousemove = null;
              document.onmouseup = null;

              // 悬浮左右滑动的逻辑
              // if (boxLeft < pageX / 2) {
              //   odiv.style.left = 0 + "px";
              //   odiv.style.transition = "left .3s";
              // } else {
              //   odiv.style.left = pageX + "px";
              //   odiv.style.transition = "left .3s";
              // }
            };
          };
        }
      },
    },
  },
  computed: {
    showFlex() {
      const routeIs = !["payGame", "otherGame", "games", "403"].includes(
        this.$route.name
      );
      return routeIs && !!this.$store.getters.user;
    },
    serviceInfo() {
      const config = this.$store.state.auth.customerService;
      return config.customerService;
    },
  },
  created() {},
  mounted() {},
  methods: {
    showPopover() {
      if (isMove) {
        isMove = false;
        return;
      }
      this.show = !this.show;
      this.$eventPost("customer_service_click");
      this.$eventPost("click", {
        eid: `101_27_0_0`,
        time: Date.now(),
      });
    },
    initPosition() {
      const obj = getLocalStorage("position") || {};
      const key = 888;
      const arr = obj[key]?.split(",") || [];
      const initX = arr[0];
      const initY = arr[1];
      const dom = document.getElementById(key);
      // console.log(dom, initX, initY);
      if (
        dom &&
        initX &&
        initY &&
        Number(initX) < document.documentElement.clientWidth
      ) {
        dom.style.position = "fixed";
        dom.style.transition = "none";
        dom.style.left = initX + "px";
        dom.style.top = initY + "px";
      }
    },
  },
};
